import { GoArrowRight } from "react-icons/go";

export const ArrowRight = ({ ...rest }) => {
  return <GoArrowRight {...rest} />;
};
